import React, { useEffect, useState } from "react";

const DEADLINE = new Date("2026-10-15T23:59:59-04:00"); // Oct 15, 2026, end of day EDT

function remaining() {
  const t = DEADLINE.getTime() - Date.now();
  const d = Math.max(0, t);
  return {
    passed: t <= 0,
    days: Math.floor(d / 86400000),
    hours: Math.floor((d % 86400000) / 3600000),
    minutes: Math.floor((d % 3600000) / 60000),
  };
}

export function RsvpCountdown() {
  const [c, setC] = useState(remaining());
  useEffect(() => {
    const i = setInterval(() => setC(remaining()), 30000);
    return () => clearInterval(i);
  }, []);

  if (c.passed) return null;

  const units = [["Days", c.days], ["Hours", c.hours], ["Minutes", c.minutes]];
  return (
    <div className="stone-panel border border-taupe/40 rounded-lg py-8 px-6 text-center mb-8" data-testid="rsvp-countdown">
      <p className="overline text-olive mb-5">Kindly respond within</p>
      <div className="flex justify-center gap-6 sm:gap-10">
        {units.map(([label, val]) => (
          <div key={label} className="text-center">
            <div className="font-serif text-4xl sm:text-5xl leading-none text-matte">{String(val).padStart(2, "0")}</div>
            <div className="overline text-taupe mt-2">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
